<template>
    <div class="b-steps">
        <div class="b-steps__nav">
            <div
                v-for="(item, idx) in nav"
                :key="`step-${item.curSlotName}`"
                @click="setCurStep(item.slot, true, item.isEmpty)"
                :class="{'_active': item.slot === curSlotName}"
                class="b-steps__item"
            >
                <div class="b-steps__counter">
                    <div v-if="item.slot === curSlotName" class="b-steps__num">
                        <svg class="b-steps__icon" width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 11.6L7.82353 16L17 5" stroke="black" stroke-width="2"/>
                        </svg>
                    </div>
                    <div v-else class="b-steps__num g-text__p _semibold">{{ idx + 1 }}</div>
                    <div class="b-steps__line">
                        <div v-if="item.slot === curSlotName && !disableDelay" :style="{maxWidth: `${progressWidth}%`}" class="b-steps__progress"></div>
                    </div>
                </div>
                <p v-html="item.title" class="b-steps__text g-text__p _semibold g-h-t-14 g-d-m-none _t-medium-alt" />
            </div>
        </div>
        <div v-if="!isSlotEmpty" class="b-steps__content">
            <slot :name="curSlotName"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            nav: {
                type: Array,
                default () {
                    return [];
                }
            },
            delay: {
                type: Number,
                default: 4
            }
        },
        data() {
            return {
                curSlotName: '',
                isSlotEmpty: false,
                progressWidth: 0,
                disableDelay: false,
                curIterate: 1,
                widthSlice: 0,
                curStep: 1,
                stopIntersection: false
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.setIntersection();
                if (this.nav.length) {
                    this.curSlotName = this.nav[0].slot;
                    this.isSlotEmpty = this.nav[0].isEmpty;
                }
            });
        },
        methods: {
            setIntersection() {
                new IntersectionObserver(
                    (entries, observer) => {
                        entries.forEach((entry) => {
                            if (!this.disableDelay && !this.stopIntersection && entry.isIntersecting) {
                                this.startMoving();
                                this.stopIntersection = true;
                            }
                        });
                    },
                    {
                        threshold: 0.1,
                    }
                ).observe(this.$el);
            },
            setCurStep(slotName, isUserClick, isEmpty) {
                if (slotName === this.curSlotName) return;
                if (isUserClick && !this.disableDelay) {
                    this.disableDelay = true;
                }

                this.curSlotName = slotName;
                this.isSlotEmpty = isEmpty;

                if (!this.disableDelay) {
                    this.startMoving();
                }
            },
            startMoving() {
                if (this.curStep >= this.nav.length) {
                    this.disableDelay = true;
                    return;
                }

                this.curIterate = 1;
                this.progressWidth = 0;
                this.widthSlice = 100 / (this.delay - 1);
                this.moveIterates();
            },
            moveIterates() {
                if (this.disableDelay) return;
                if (this.curIterate > this.delay) {
                    this.curStep += 1;
                    this.setCurStep(
                        this.nav[this.curStep - 1].slot,
                        false,
                        this.nav[this.curStep - 1].isEmpty
                    );
                    return;
                }

                setTimeout(() => {
                    this.curIterate += 1;
                    this.progressWidth += this.widthSlice;
                    this.moveIterates();
                }, 1000);
            }
        }
    }
</script>
